<template>
  <div class="container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/yunwei' }">运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>采集端管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="search-card">
      <div class="toolbar">
        <el-button type="primary" @click="handleAdd">添加采集端</el-button>
      </div>
    </el-card>

    <el-card>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="name" label="名称" width="120" />
        <el-table-column prop="url" label="地址" min-width="200" />
        <el-table-column label="微灵" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.weworkEnabled ? 'success' : 'info'" size="small">
              {{ scope.row.weworkEnabled ? '启用' : '关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑弹窗 -->
    <el-dialog :title="isEdit ? '编辑采集端' : '添加采集端'" :visible.sync="dialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="如：服务器A" maxlength="20" />
        </el-form-item>
        <el-form-item label="地址" prop="url">
          <el-input v-model="form.url" placeholder="http://192.168.1.100:7010" />
        </el-form-item>
        <el-form-item label="ApiKey" prop="apiKey">
          <el-input v-model="form.apiKey" placeholder="HMAC签名密钥" />
        </el-form-item>
        <el-form-item label="ApiSecret" prop="apiSecret">
          <el-input v-model="form.apiSecret" placeholder="HMAC签名密钥" type="password" show-password />
        </el-form-item>
        <el-form-item label="启用微灵">
          <el-switch v-model="form.weworkEnabled" active-text="是" inactive-text="否" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">{{ isEdit ? '保存' : '添加' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CollectorManage',
  data () {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      editId: null,
      submitting: false,
      form: {
        name: '',
        url: '',
        apiKey: '',
        apiSecret: '',
        weworkEnabled: false
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        apiKey: [{ required: true, message: '请输入ApiKey', trigger: 'blur' }],
        apiSecret: [{ required: true, message: '请输入ApiSecret', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('yunwei/collector/list')
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list || []
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleAdd () {
      this.isEdit = false
      this.editId = null
      this.dialogVisible = true
    },
    handleEdit (row) {
      this.isEdit = true
      this.editId = row._id
      this.form = {
        name: row.name,
        url: row.url,
        apiKey: row.apiKey,
        apiSecret: row.apiSecret,
        weworkEnabled: row.weworkEnabled
      }
      this.dialogVisible = true
    },
    async handleDelete (row) {
      try {
        await this.$confirm(`确定删除采集端「${row.name}」吗？删除后关联的品牌将无法正常工作。`, '提示', { type: 'warning' })
        const { data: res } = await this.$http.delete('yunwei/collector/remove', { data: { id: row._id } })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('已删除')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    },
    async submitForm () {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      try {
        const payload = { ...this.form }
        let res
        if (this.isEdit) {
          payload.id = this.editId
          res = await this.$http.put('yunwei/collector/modify', payload)
        } else {
          res = await this.$http.post('yunwei/collector/add', payload)
        }
        if (res.data.meta.status !== 200) return this.$message.error(res.data.meta.msg)
        this.$message.success(this.isEdit ? '已保存' : '已添加')
        this.dialogVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.submitting = false
      }
    },
    resetForm () {
      this.form = {
        name: '',
        url: '',
        apiKey: '',
        apiSecret: '',
        weworkEnabled: false
      }
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom: 0; }
</style>
